import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconDragIndicatorLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 19.615c-.444 0-.824-.158-1.14-.474A1.556 1.556 0 0 1 7.384 18c0-.444.158-.824.474-1.14A1.555 1.555 0 0 1 9 16.384c.444 0 .824.158 1.14.474.317.317.475.697.475 1.141 0 .444-.158.824-.474 1.14A1.556 1.556 0 0 1 9 19.616Zm6 0c-.444 0-.824-.158-1.14-.474A1.555 1.555 0 0 1 13.384 18c0-.444.158-.824.474-1.14A1.555 1.555 0 0 1 15 16.384c.444 0 .824.158 1.14.474.317.317.475.697.475 1.141 0 .444-.158.824-.474 1.14a1.556 1.556 0 0 1-1.141.475Zm-6-6c-.444 0-.824-.158-1.14-.474A1.556 1.556 0 0 1 7.384 12c0-.444.158-.824.474-1.14A1.555 1.555 0 0 1 9 10.384c.444 0 .824.158 1.14.474.317.317.475.697.475 1.141 0 .444-.158.824-.474 1.14A1.556 1.556 0 0 1 9 13.616Zm6 0c-.444 0-.824-.158-1.14-.474A1.555 1.555 0 0 1 13.384 12c0-.444.158-.824.474-1.14A1.555 1.555 0 0 1 15 10.384c.444 0 .824.158 1.14.474.317.317.475.697.475 1.141 0 .444-.158.824-.474 1.14a1.556 1.556 0 0 1-1.141.475Zm-6-6c-.444 0-.824-.158-1.14-.474A1.555 1.555 0 0 1 7.384 6c0-.444.158-.824.474-1.14A1.555 1.555 0 0 1 9 4.384c.444 0 .824.158 1.14.474.317.317.475.697.475 1.141 0 .444-.158.824-.474 1.14A1.556 1.556 0 0 1 9 7.616Zm6 0c-.444 0-.824-.158-1.14-.474A1.555 1.555 0 0 1 13.384 6c0-.444.158-.824.474-1.14A1.555 1.555 0 0 1 15 4.384c.444 0 .824.158 1.14.474.317.317.475.697.475 1.141 0 .444-.158.824-.474 1.14A1.556 1.556 0 0 1 15 7.616Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconDragIndicatorLine;
